export default __webpack_public_path__ + "media/images/backgrounds/cream-vegetables-2dfa1ef8fc8f0e91bbae24019da36159.svg";